module.exports = "/call-frontend/img/黄.9a41510b.png";